import {
  Switch as MuiSwitch,
  SwitchProps,
  lighten,
  alpha,
  Theme,
} from "@mui/material";
import { COLORS } from "../../../../constants/colors";

const switchSxProps = {
  ".MuiSwitch-track": {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  ".MuiSwitch-switchBase": {
    "&.Mui-disabled": {
      color: COLORS.WHITE,
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "primary.main",
    },
  },
  ".Mui-disabled": {
    "&.Mui-checked": {
      color: (theme: Theme) => lighten(theme.palette.primary.main, 0.62), //.38
    },
  },
  ".Mui-checked": {
    color: "primary.main",
    "&:hover": {
      backgroundColor: (theme: Theme) =>
        alpha(theme.palette.primary.main, 0.04), //.04
    },
    "&:focus": {
      border: (theme: Theme) => `1px solid ${theme.palette.primary.main}`,
    },
  },
};

const Switch = (props: SwitchProps): JSX.Element => {
  return <MuiSwitch sx={switchSxProps} color="default" {...props} />;
};

export default Switch;
